import React, { Component /*,Fragment*/ } from 'react';
import { putToast, getObjects, loadObject, adminloadTP, deleteObject, updateObject, /*tournamentAddRound, tournamentUpdateRound, tournamentRemoveRound,*/ AuthenticatedUser, stopTimer } from "../../../api";
//import { List, HelpCircle, BarChart2 } from 'react-feather';
//import BDBQueryCube from '../../../pages/pageParts/bdbQueryCube';
import TournamentPageTemplate from '../tournamentPageTemplate'
//import RoundTemplateCube from '../cubes/config/roundAvailabilityCube';
//import InputRow from '../../../pages/pageParts/inputForms/inputRow';
import { AvField, AvForm } from 'availity-reactstrap-validation';
//import DateTimePicker from 'react-datetime-picker';
//import { now } from 'moment';
//import TagList from "../../../common/tagList"
//import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
//const _ = require("lodash");

class TournamentConfigPrompts extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onRemoveList = this.onRemoveList.bind(this);
        this.onSaveList = this.onSaveList.bind(this);
        this.onPromptListDetails = this.onPromptListDetails.bind(this);
        this.getTdProps = this.getTdProps.bind(this);
        this.useid = null;

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            selectedList: null,
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('promptList').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            this.setState({ pid: pid, tData: d2.tournamentPage, tUsers: d2.tUsers, promptLists: d3, loading: false});                    
                        }
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    onPromptListDetails(selectedId) {
        loadObject('promptList', selectedId).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ selectedList: d2 });
                //this.form && this.form.reset()                   
            }
        });
    }

    onValidSubmit = (event, values) => {
        const {selectedList} = this.state;
        const id = this.useid;

        const formData = new FormData(document.getElementById('mainForm'));

        updateObject('promptList', formData, id).then(d2 => {
            if (d2.error) {
                console.log(d2.error);
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                getObjects('promptList').then(d3 => {
                    if (d3 && d3.error) {
                        console.log(d3.error);
                    } else {
                        putToast.success(d2.message);    
                        this.setState({ promptLists: d3, selectedList: d3.find(x=>x._id === selectedList._id) });   
                    }
                });
            }
        });  
    };
    

    onInvalidSubmit = (round, errors, values) => {
        //this.setState({errors, values});
    };

    onSaveList(ev) {
        //ev.preventDefault();
        if (ev.target.name === 'sa') this.useid = this.state.selectedList ? this.state.selectedList._id : null;
        else this.useid = null;
    }

    onRemoveList(ev) {
        ev.preventDefault();

        deleteObject('promptList', this.state.selectedRound._id).then(d2 => {
            if (d2.error) {
                console.log(d2.error);
            } else {
                getObjects('promptList').then(d3 => {
                    if (d3 && d3.error) {
                        console.log(d3.error);
                    } else {
                        putToast.success(d2.message);    
                        this.setState({ promptLists: d3});   
                    }
                });                
            }
        });
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "isResolved") {
            return {                
                onClick: () => { 
                    this.setState({ selectedList: rowInfo.original })
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        this.form && this.form.reset() 
        
    }

    render(){
        if (this.state.loading) { return null; }

        stopTimer();      
        const { tData, promptLists, user, selectedList } = this.state;
        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Configuration - ${user.displayname}`} title3=""
            bcTitle="Configure Prompts" bcParents={[{name: tData.title, url: `/tournament/config/${tData._id}`}]} 
        >                     
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Prompt Lists</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                <ReactTable
                                    filterable
                                    defaultFilterMethod={ (filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }}
                                    data={promptLists}
                                    columns={[{
                                        Header: 'Abbr',
                                        accessor: 'abbr',
                                        maxWidth: 130,                                   
                                    },{
                                        Header: 'Title',
                                        accessor: 'title',
                                        width: 360,                                   
                                    },{
                                        Header: 'Category',
                                        accessor: 'category',
                                        style: { 'whiteSpace': 'unset' }
                                    },{
                                        Header: 'Status',
                                        accessor: 'status',
                                        style: { 'whiteSpace': 'unset' }
                                    }]}                                        
                                    defaultPageSize={15}
                                    showPagination={true}  
                                    getTdProps={this.getTdProps}                                                                                                     
                                />
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;
                            </div>
                        </div> 


                    </div>
                    <div className="col-sm-6">                         
                        <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={selectedList} ref={c => (this.form = c)}>
                            <div className="card" style={{marginBottom: "10px"}}>
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                    <h4>Prompt List Details
                                    {selectedList && <button style={{margin: "0px 4px"}} type="button" className="btn btn-primary pull-right" onClick={this.onRemoveList}>Remove</button> }
                                    {selectedList && <button  style={{margin: "0px 4px"}} className="btn btn-primary pull-right" name="sa" type="submit" onClick={this.onSaveList}>Save</button> }
                                    <button  style={{margin: "0px 4px"}} className="btn btn-primary pull-right" name="sas" type="submit" onClick={this.onSaveList}>Save As</button>
                                    </h4>     
                                </div>   
                                <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                                    <AvField label="Abbr" grid={{xs: 10}} name="abbr" id="abbr" type="text" />
                                    <AvField label="Category" grid={{xs: 10}} name="category" id="category" type="select">                                 
                                        <option disabled value="">Select Category</option>                                 
                                        <option value="parli" key="parli">Parliamentary</option>                                 
                                        <option value="apol" key="apol">Apologetics</option>                                                                                                                    
                                        <option value="extemp" key="extemp">Extemporaneous</option>                                                                                                                    
                                        <option value="improptu" key="improptu">Impromptu</option>                                                                                                                    
                                    </AvField>                                    
                                    <AvField label="Status" grid={{xs: 10}} name="status" id="status" type="select">                                 
                                        <option disabled value="">Select Status</option>                                 
                                        <option value="draft" key="draft">Draft</option>                                 
                                        <option value="private" key="private">Private</option>                                                                                                                    
                                        <option value="publish" key="publish">Public</option>                                                                                                                    
                                    </AvField>                                            
                                    <AvField label="Content" grid={{xs: 10}} name="content" id="content" type="textarea" rows="20" style={{
                                        whiteSpace: "nowrap",
                                        overflowY:  "scroll",
                                        overflowX:  "scroll",
                                        overflow:   "scroll -moz-scrollbars-horizontal -moz-scrollbars-vertical"
                                    }}/>                                             
                                </div>
                                <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                    &nbsp;
                                </div>
                            </div> 
                        </AvForm>
                    </div>
                </div>  
            </div>
            </TournamentPageTemplate>
            
        )
    }
}

export default TournamentConfigPrompts;